import { render, staticRenderFns } from "./CoursesList.vue?vue&type=template&id=260d6d9b&scoped=true"
import script from "./CoursesList.vue?vue&type=script&lang=js"
export * from "./CoursesList.vue?vue&type=script&lang=js"
import style0 from "./CoursesList.vue?vue&type=style&index=0&id=260d6d9b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260d6d9b",
  null
  
)

export default component.exports